var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRealState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_49199)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_49199)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_979_49199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4385 20.4583L16.6631 19.5425L16.2385 19.902V20.4583H17.4385ZM17.4385 36.75H16.2385C16.2385 37.0683 16.3649 37.3735 16.5899 37.5985C16.815 37.8236 17.1202 37.95 17.4385 37.95L17.4385 36.75ZM39.1906 36.75V37.95C39.8534 37.95 40.3906 37.4127 40.3906 36.75H39.1906ZM39.1906 20.4583H40.3906V19.902L39.966 19.5425L39.1906 20.4583ZM28.3146 11.25L29.09 10.3342C28.6424 9.95528 27.9867 9.95528 27.5391 10.3342L28.3146 11.25ZM16.2385 20.4583V36.75H18.6385V20.4583H16.2385ZM40.3906 36.75V20.4583H37.9906V36.75H40.3906ZM17.4385 37.95C23.7829 37.95 32.8462 37.95 39.1906 37.95V35.55C32.8462 35.55 23.7829 35.55 17.4385 35.55L17.4385 37.95ZM27.5391 10.3342L16.6631 19.5425L18.2139 21.3742L29.09 12.1658L27.5391 10.3342ZM39.966 19.5425L29.09 10.3342L27.5391 12.1658L38.4152 21.3742L39.966 19.5425Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.795 26.8333C26.795 25.4352 25.6952 24.2167 24.2355 24.2167C22.7758 24.2167 21.676 25.4352 21.676 26.8333C21.676 28.2314 22.7758 29.45 24.2355 29.45C25.6952 29.45 26.795 28.2314 26.795 26.8333Z",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7526 28.032C34.4154 28.032 34.9526 27.4948 34.9526 26.832C34.9526 26.1693 34.4154 25.632 33.7526 25.632L33.7526 28.032ZM26.9551 28.032L33.7526 28.032L33.7526 25.632L26.9551 25.632L26.9551 28.032Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3926 29.8086L32.3926 26.9753",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_49199",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_49199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_49199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_979_49199",
    x: -12,
    y: -9,
    width: 80.6279,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_49199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_49199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_49199"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRealState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/real-state.79a448e3a641e2dfd407266c8bd0985a.svg";